import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { Contact } from '../../../api/app-types/contact.app';
import { CUSTOM_DATE_FORMATS } from '../../../core/adapters/custom-date-format';
import { calculateRemainingEditDays } from '../../../shared/helpers/remaining-edit-days.func';
import { RouteInjection } from '../../../shared/routing/route-injection.class';

@Component({
	selector: 'lvr-contact-card',
	imports: [TranslocoPipe, DatePipe, MatIcon],
	templateUrl: './contact-card.html',
	styleUrl: './contact-card.scss',
})
export class ContactCard extends RouteInjection {
	public readonly environment = inject(ENVIRONMENT);
	public readonly dateDisplayFormat: string = CUSTOM_DATE_FORMATS.display.dateInput;
	public readonly contact = input.required<Contact>();
	public readonly hasBottomBorder = input<boolean>(false);
	public readonly isFrozen = computed(() => this.contact().isFrozen);
	public readonly canEdit = computed(() => !this.isFrozen() && this.timeToEditAsDays() >= 0);
	public readonly showDocuments = input<boolean>(false);
	public readonly showRemarks = input<boolean>(true);
	public readonly showEdit = input<boolean>(true);
	public readonly clientId = input<number>();
	public readonly timeToEditAsDays = computed(() => {
		return calculateRemainingEditDays(
			this.contact().contactedAt,
			this.environment.formConfiguration.contact.updateCreatePeriodAsDays,
		);
	});

	public readonly editabilityMessage = computed(() => {
		const days = this.timeToEditAsDays();

		switch (true) {
			case days < 0:
				return '';
			case days === 0:
				return 'Noch heute bearbeitbar';
			default:
				return `Noch ${days} Tage bearbeitbar`;
		}
	});
}
